import { ServicePerval } from '../../models/service-perval';

export const getServicePervalName = (code: string): ServicePerval.Name => {
  switch (code) {
    case 'LRV':
      return {
        code: 'LRV',
        label: 'Liste de références',
        description:
          'Références de vente achetées en décompte forfaitaire des crédits',
      };
    case 'EvAu':
      return {
        code: 'EvAu',
        label: 'Evaluation automatique',
        description: "Evaluation automatique d'un bien",
      };
    case 'Eval':
      return {
        code: 'Eval',
        label: 'Evaluation manuelle',
        description: "Evaluation manuelle d'un bien",
      };
    default:
      return {
        code: 'AUT',
        label: 'Autre',
        description: 'Autre',
      };
  }
};

export const getServicePervalUrl = (
  code: string,
  historyId?: string,
  evaluationId?: string,
): string => {
  switch (code) {
    case 'LRV':
      return `recherche-references/achat/${historyId}`;
    case 'EvAu':
      return `evaluation-automatique/search?evaluationId=${evaluationId}`;
    case 'Eval':
      return `recherche-references/achat/${historyId};evaluationId=${evaluationId}`;
    default:
      // Normalement, on ne devrait jamais arriver ici, mais on retourne une valeur par défaut pour éviter les erreurs
      return `v2/historique-des-services`;
  }
};
